import { CartService } from '../../services/cart.service';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NavController, ToastController, AlertController, IonInput, ModalController, PickerController, PopoverController, LoadingController, IonContent } from '@ionic/angular';
import { ServicioService } from '../../services/servicio.service';
import { Router } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'app-cart',
    templateUrl: './cart.page.html',
    styleUrls: ['./cart.page.scss'],
})
export class CartPage implements OnInit {
    @ViewChild('inputValor') myInput: IonInput;
    // @ViewChild('content') content: IonContent;
    @ViewChild('nif') nif: IonInput;
    @ViewChild('nombre') nombre: IonInput;
    @ViewChild('cc') cc: IonInput;
    @ViewChild('celular') celular: IonInput;

    cartItems: any[];
    hideCart = true;

    items = [];

    total = 0;
    totalUnidades = 0;

    pais = 'co';
    mayorista = false;
    formMayorista: FormGroup;
    submitted = false;
    formDSI: FormGroup;
    preventa = false;

    cargando = true;

    regex1 = '^[A-Za-zÀ-ÿ0-9\u00f1\u00d1 ]+(?: [A-Za-z0-9À-ÿ\u00f1\u00d1])*$';

    constructor(
        public navCtrl: NavController,
        private service: ServicioService,
        private cart: CartService,
        private toastCtrl: ToastController,
        private alertCtrl: AlertController,
        private loadingCtrl: LoadingController,
        private formBuilder: FormBuilder,
        private popoverCtrl: PopoverController,
        private modalCtrl: ModalController,
        private pickerController: PickerController,
        private router: Router) {

        this.service.getVariable('pais').then((val) => {
            this.pais = val;
        });


    }

    get f() { return this.formMayorista.controls; }
    get f2() { return this.formDSI.controls; }

    async ngOnInit() {

        this.formMayorista = new FormGroup({
            nif: new FormControl('', [Validators.required, Validators.minLength(4)]),
            nombre: new FormControl('', [Validators.required, Validators.minLength(4)])
        });

        this.formDSI = new FormGroup({
            cc: new FormControl('', [Validators.required, Validators.minLength(4), Validators.pattern(this.regex1)]),
            nombre: new FormControl('', [Validators.required, Validators.minLength(4), Validators.pattern(this.regex1)]),
            celular: new FormControl('', [Validators.required, Validators.minLength(4), Validators.pattern(this.regex1)])
        });

    }

    async ionViewWillEnter() {

        await this.cargarDatos();
    }

    async cargarDatos(animacion: boolean = true) {
        this.hideCart = true;
        await this.cart.getCartItems().then((val) => {
            this.cartItems = val;
            if (this.cartItems.length !== 0) {
                if (val !== 0) {
                    this.hideCart = false;
                    this.totalAPagar();
                } else {
                    this.cargando = false;
                }
            } else {
                this.cargando = false;
            }
        });
    }

    // TODODMG: FLETE se toma de donde ? valor y venta minima

    async totalAPagar() {

        this.total = 0;
        this.totalUnidades = 0;

        await this.cart.getCartItems().then(async (val) => {
            this.cartItems = val;

            this.items = [];

            for (let index = 0; index < this.cartItems.length; index++) {
                const element = this.cartItems[index];

                if (element.offerPrice === null) {
                    element.offerPrice = 0;
                }

                const item = {
                    ean: element.product_id,
                    sku: element.reference + ' ' + element.color + ' ' + element.presentationSize,
                    marca: element.tipo === 'fisico' ? '0' : element.tipo === 'estandar' ? '999' : '888',
                    precioUnitario: element.offerPrice > 0 ? element.offerPrice : element.retailPrice,
                    size: element.size,
                    cantidad: element.count
                };

                this.items.push(item);

                this.total += (element.offerPrice > 0 ? element.offerPrice : element.retailPrice) * element.count;
                this.totalUnidades += element.count;


            }

            this.cargando = false;

        });


    }

    async removerItem(item) {

        const confirm = await this.alertCtrl.create({
            header: 'Eliminar de la bolsa',
            message: 'Desea eliminar el producto: (' + item.parent + ') ' + item.name + ' ?',
            buttons: [
                {
                    text: 'No',
                    handler: () => {
                        // console.log('Disagree clicked');
                    }
                },
                {
                    text: 'Si',
                    handler: () => {

                        this.cargando = true;

                        this.cart.removeFromCart(item.id).then((result) => {
                            this.presentToast();
                            this.totalAPagar();
                            // this.cargarDatos();
                        });

                    }
                }
            ]
        });
        confirm.present();

    }


    async removerTodos() {

        const confirm = await this.alertCtrl.create({
            header: 'Eliminar de la bolsa',
            message: 'Desea eliminar TODOS los productos de la bolsa ?',
            buttons: [
                {
                    text: 'No',
                    handler: () => {
                        // console.log('Disagree clicked');
                    }
                },
                {
                    text: 'Si',
                    handler: () => {

                        this.cart.removeAllCartItems().then((result) => {
                            this.presentToast();
                            this.ionViewWillEnter();
                            this.cargarDatos();
                        });

                    }
                }
            ]
        });
        confirm.present();

    }

    async presentToast() {
        const toast = await this.toastCtrl.create({
            message: 'Producto eliminado de la bolsa',
            duration: 3000,
            position: 'bottom'
        });

        await toast.onDidDismiss();
        await toast.present();
    }

    decreaseProductCount(item) {
        if (item.count > 1) {
            item.count--;
            item.totalPrice = (item.offerPrice > 0 ? item.offerPrice : item.retailPrice) * item.count;
            this.cart.updateCart(item).then(async () =>
                await this.cargarDatos(false)
            );
        }
    }

    async incrementProductCount(item) {
        item.count++;
        item.totalPrice = (item.offerPrice > 0 ? item.offerPrice : item.retailPrice) * item.count;
        this.cart.updateCart(item).then(async () =>
            await this.cargarDatos(false)
        );
    }

    async unidades(valor: any, item: any) {

        if (valor === '' || valor === undefined) {
            this.myInput.setFocus();
            return;
        }

        if (valor === '0') {
            item.count = 1;
        } else {
            item.count = valor;
        }
        this.myInput = await item.count;

        item.totalPrice = await (item.offerPrice > 0 ? item.offerPrice : item.retailPrice) * item.count;
        await this.cart.updateCart(item).then(() => {
            this.cargarDatos();
        });
        await this.myInput.setFocus();
    }

    enviarTienda() {


        let pais = 'col';
        let asesora = '003Tienda02RDL';

        if (this.pais === 'pe') {
            pais = 'pe';
            asesora = 'PERTienda02RDL';
        } else if (this.pais === 'cr') {
            pais = 'cr';
            asesora = 'COSTienda02RDL';
        } else if (this.pais === 'cl') {
            pais = 'cl';
            asesora = 'CHLTienda02RDL';
        } else if (this.pais === 'es') {
            pais = 'eu-sp';
            asesora = 'ESPTienda02RDL';
        } else if (this.pais === 'pr') {
            pais = 'pr';
            asesora = 'PRITienda02RDL';
        } else if (this.pais === 'mx') {
            pais = 'mx';
            asesora = 'MEXTienda02RDL';
        } else {
            pais = 'col';
            asesora = '003Tienda02RDL';
        }


        const url = 'https://www.leonisa.com/' + pais + '/store/addcart/?sku=';

        let itemsW = '';

        let qty = '';

        this.items.forEach(element => {

            const ref = element.sku.split(' ')[0]

            const ref1 = ref.length === 4 ? ref + '%20%20%20%20' : ref.length === 5 ? ref + '%20%20%20' : ref.length === 6 ? ref + '%20%20' : ref.length === 7 ? ref + '%20' : ref;

            const col = element.sku.split(' ')[1];
            let tal = element.size.trim() === '' ? element.sku.split(' ')[2] : element.size.trim();

            if (this.pais === 'cl') {
                //  convertir tallas
                if (tal === 'XS') {
                    tal = '45';
                }
                if (tal === 'S') {
                    tal = '50';
                }
                if (tal === 'M') {
                    tal = '55';
                }
                if (tal === 'L') {
                    tal = '60';
                }
                if (tal === 'XL') {
                    tal = '65';
                }
                if (tal === 'XXL') {
                    tal = '70';
                }
            }

            if (itemsW !== '') {
                itemsW += ',';
            }

            const tal1 = tal.replace('A', '').replace('B', '').replace('C', '').replace('D', '').replace('DD', '').replace('/S', '').replace('/M', '').replace('/L', '').replace('/XL', '').replace('/XXL', '').replace('UNIQUE', '65');

            const tal2 = tal1.length === 1 ? '%20%20%20' + tal1 : '%20%20' + tal1;


            itemsW += ref1 + col + tal2;
            if (qty !== '') {
                qty += ',';
            }
            qty += element.cantidad
        });

        const final = '&Quantity=' + qty + '&ref=' + asesora;

        const todos = url + itemsW + final + '&utm_source=catalogo_digital&utm_medium=checkout_compra_finalizar&utm_campaign=3d';

        window.open(todos, '_blank');
    }


    PadRight(value, length) {
        return (value.toString().length < length) ? this.PadRight(value.trim() + '20%', length) : value;
    }

    enviarWhatsapp(num = 1) {

        this.submitted = true;

        if (num === 3) {
            if (!this.formMayorista.valid) {
                return;
            }
        }

        let whatsapp = '573224019983';
        let whatsapp1 = '';
        let simbolo = '%24%C2%A0';
        let decimales = 0;
        if (this.pais === 'pe') {
            whatsapp = '51940654398';
            simbolo = 'S%2F%20';
            decimales = 2;
        } else if (this.pais === 'cr') {
            whatsapp = '50684304042';
            simbolo = '%E2%82%A1%20';
            decimales = 0;
        } else if (this.pais === 'cl') {
            whatsapp = '56965979550';
            simbolo = '%24%C2%A0'
            decimales = 0;
        } else if (this.pais === 'pa') {
            whatsapp = '50769899915';
            simbolo = 'B%2F%20'
            decimales = 2;
        } else if (this.pais === 'ec') {
            whatsapp = '593991656228';
            whatsapp1 = '593990623713';
            simbolo = '%24%C2%A0'
            decimales = 2;
        } else if (this.pais === 'es') {
            whatsapp = '34616966027';
            simbolo = '%E2%82%AC'
            decimales = 2;
        } else if (this.pais === 'pr') {
            whatsapp = '17872491009';
            simbolo = '%24%C2%A0'
            decimales = 2;
        } else if (this.pais === 'mx') {
            whatsapp = '525544990737';
            simbolo = '%24%C2%A0'
            decimales = 2;
        } else {
            whatsapp = '573224019983';
            simbolo = '%24%C2%A0';
            decimales = 0;
        }

        const wh = num === 2 ? whatsapp1 : whatsapp;

        const url = 'https://api.whatsapp.com/send?phone=' + wh + '&text=';
        const saludo = '¡Hola!%0D%0A%0D%0AEstos%20son%20los%20productos%20que%20quiero%20solicitar%20de%20Leonisa.%20%0D%0A%0D%0A';

        let itemsW = '';

        this.items.forEach(element => {
            itemsW += element.cantidad + '%20x%20Referencia%3A%20' + element.sku.split(' ')[0] +
                '%20-%20Talla%3A%20' + element.sku.split(' ')[2] + '%20Color%3A%20' + element.sku.split(' ')[1] + '%20EAN%3A%20' + element.ean +
                '%20por%3A%20' + simbolo + Number(element.precioUnitario).toFixed(decimales) + '%20%0D%0A%0D%0A';
        });

        // Simbolo pesos = %24%C2%A0

        const final = 'El%20total%20de%20mi%20compra%20es%20de%3A%20' + simbolo + Number(this.total).toFixed(decimales) + '%0D%0A%0D%0AConfírmame%20si%20puedes%20realizar%20mi%20pedido.%0D%0A%0D%0A¡Muchas%20gracias!';

        let mayorista = '';

        if (num === 3) {
            mayorista = '%20-%20Para%20mayorista%20con%20NIF%3A%20' + this.formMayorista.value.nif + '%20-%20Nombre%3A%20' + this.formMayorista.value.nombre + '%20-%20';
        }


        const todos = url + saludo + itemsW + mayorista + final;

        window.open(todos, '_blank');

    }

    seleccionaMayorista() {
        this.mayorista = true;
        // this.content.nativeElement.scrollToBottom(800);
    }

    seleccionaDSI() {
        this.preventa = true;
        // this.content.nativeElement.scrollToBottom(800);
    }

    async guardarPedido() {

        const loader = await this.loadingCtrl.create(
            {
                spinner: 'bubbles',
                message: 'Guardando tu pedido...'
            });

        await loader.present().then(async () => {

            this.submitted = true;

            if (!this.formDSI.valid) {
                loader.dismiss();
                return;
            }

            let numero: any = 1;

            await this.service.getnum().then(res => {

                if (res.msg === undefined) {
                    numero = 1;
                } else {
                    numero = res.msg;
                }

                const ciu = this.formDSI.value.nombre;

                const nombreReparado = ciu.replace('.', '').replace(',', '').replace('Á', 'A').replace('É', 'E').replace('Í', 'I').replace('Ó', 'O').replace('Ú', 'U').replace('Ñ', 'N').replace('á', 'a').replace('é', 'e').replace('í', 'i').replace('ó', 'o').replace('ú', 'u').replace('ñ', 'n').replace('Ü', 'U').replace('ü', 'u');

                const json = {
                    cedula: this.formDSI.value.cc,
                    nombre: nombreReparado,
                    pedido: numero,
                    celular: this.formDSI.value.celular,
                    fecha: new Date(),
                    unidades: this.totalUnidades,
                    aplicacion: 'T3D',
                    accion: 'G',
                    items: this.items
                }

                this.service.dsiPreventa(json).then(async res1 => {

                    if (res1.ok !== undefined) {

                        const alert = await this.alertCtrl.create({
                            header: 'Atención',
                            message: '¡ Tuvimos un problema guardando tu pedido, reintenta !',
                            buttons: ['Aceptar']
                        });
                        await alert.present();
                        loader.dismiss();
                    } else {
                        const result = JSON.parse(res1);

                        if (result.Table !== undefined) {
                            if (result.Table[0].resultado !== undefined) {
                                if (JSON.parse(result.Table[0].resultado)[0].code === 0) {
                                    const alert = await this.alertCtrl.create({
                                        header: 'Pedido Grabado',
                                        message: '¡ Tu pedido fue grabado con exito con el número: ' + numero + ' !',
                                        buttons: ['Aceptar']
                                    });
                                    await alert.present();
                                    this.cart.removeAllCartItems().then(() => {
                                        this.popoverCtrl.dismiss();
                                    });
                                    loader.dismiss();
                                } else {
                                    const alert = await this.alertCtrl.create({
                                        header: 'Atención',
                                        message: '¡ Tuvimos un problema guardando tu pedido, reintenta !',
                                        buttons: ['Aceptar']
                                    });
                                    await alert.present();
                                    loader.dismiss();
                                }

                            } else {
                                const alert = await this.alertCtrl.create({
                                    header: 'Atención',
                                    message: '¡ Tuvimos un problema guardando tu pedido, reintenta !',
                                    buttons: ['Aceptar']
                                });
                                await alert.present();
                                loader.dismiss();
                            }
                        } else {
                            const alert = await this.alertCtrl.create({
                                header: 'Atención',
                                message: '¡ Tuvimos un problema guardando tu pedido, reintenta !',
                                buttons: ['Aceptar']
                            });
                            await alert.present();
                            loader.dismiss();
                        }
                    }

                });

            });
        });
    }

}
